import { pickBy, identity } from 'lodash-es';
import keys from './keys';
import useApiQuery from '../useApiQuery';

export const DEFAULT_PARAMS = {
  fields: 'title cover status isPrivate redirect redirectUrl network lastEditedDate marketplace',
  populate: 'network',
};

export const getQueryParams = (params) => {
  const urlParams = Object.assign({}, DEFAULT_PARAMS, params);
  const filteredParams = pickBy(urlParams, identity);
  return new URLSearchParams(filteredParams).toString();
};

const useGetShows = (params, options) => {
  const queryParams = getQueryParams(params);

  const query = useApiQuery({
    queryKey: keys().shows(queryParams),
    requestUrl: `/shows${queryParams ? `?${queryParams}` : ''}`,
    disabled: options?.disable,
  });

  const data = query.data?.results || query?.data;

  return {
    shows: data,
    hasMultipleShows: query.data?.info?.total > 1 || data?.length > 1,
    showsTotal: query.data?.info?.total || data?.length,
    currentShowPage: query.data?.info?.page,
    showsError: query.error,
    isShowsFetchError: query.isError,
    isShowsFetchSuccess: query.isSuccess,
    isShowsFetching: query.isFetching,
    isShowsLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetShows;
